/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The source type of the asset, either a CHARGER or an ESS.
 *
 */
export var AssetSourceTypeChargerOrEss;
(function (AssetSourceTypeChargerOrEss) {
    AssetSourceTypeChargerOrEss["CHARGER"] = "CHARGER";
    AssetSourceTypeChargerOrEss["ESS"] = "ESS";
})(AssetSourceTypeChargerOrEss || (AssetSourceTypeChargerOrEss = {}));
